import LTR from "@brand-icons/ploom/ui-logout/ui-logout-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiLogoutIcon = iconFactory("UiLogoutIcon", LTR);
